import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBuDsQklv-ijpnACu07MaS1eiXSsp7uBKE",
  authDomain: "mehendi-pos.firebaseapp.com",
  projectId: "mehendi-pos",
  storageBucket: "mehendi-pos.firebasestorage.app",
  messagingSenderId: "441698191600",
  appId: "1:441698191600:web:e03d1535c00683e8575a35"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
